import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './ComponentIcons.css';
import withStyles from '../../decorators/withStyles';


class ComponentIcons extends Component {

  static defaultProps = {
    extLink: null,
    info: true,
    hasSettings: true,
    tutorialUrl: null,
    hasDownload: true,
    printable: false,
  };

  render() {
    const { extLink, hasDownload, hasSettings, info, openDownload,
            openInfo, openSettings, printable, tutorialUrl } = this.props;
    return (
      <span className="ComponentIcons">
        { extLink ? extLink : null}
        { hasSettings ?
          <svg onClick={openSettings} className="icon settings" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
            <path d="M3.5 0l-.5 1.19c-.1.03-.19.08-.28.13l-1.19-.5-.72.72.5 1.19c-.05.1-.09.18-.13.28l-1.19.5v1l1.19.5c.04.1.08.18.13.28l-.5 1.19.72.72 1.19-.5c.09.04.18.09.28.13l.5 1.19h1l.5-1.19c.09-.04.19-.08.28-.13l1.19.5.72-.72-.5-1.19c.04-.09.09-.19.13-.28l1.19-.5v-1l-1.19-.5c-.03-.09-.08-.19-.13-.28l.5-1.19-.72-.72-1.19.5c-.09-.04-.19-.09-.28-.13l-.5-1.19h-1zm.5 2.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"/>
          </svg>
          : null }
        { hasDownload ?
            printable ?
                <svg onClick={openDownload} className="icon download" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
                  <path d="M2 0v2h4v-2h-4zm-1.906 3c-.06 0-.094.034-.094.094v2.813c0 .06.034.094.094.094h.906v-2h6v2h.906c.06 0 .094-.034.094-.094v-2.813c0-.06-.034-.094-.094-.094h-7.813zm1.906 2v3h4v-3h-4z" id="print" />
                </svg>
                :
                <svg onClick={openDownload} className="icon stroke-based" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.1 20.1">
                  <g>
                    <circle fill="none" cx="10.1" cy="10.1" r="9.3"/>
                    <polyline fill="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="14.2,7.7 10.1,11.9 5.9,7.7  "/>
                    <line fill="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="10.1" y1="11.9" x2="10.1" y2="3.4"/>
                    <line fill="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="5.9" y1="14.6" x2="14.2" y2="14.6"/>
                  </g>
                </svg>
            : null
        }
        { info ?
          <svg onClick={openInfo} className="icon info" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <g>
              <g>
                <g><path d="M8.9,16.7l1.7-9.2C10.6,7.1,11,6.9,11.4,7C11.8,7,12.1,7.4,12,7.7L10.3,17c-0.1,0.4-0.4,0.6-0.9,0.5 C9.1,17.4,8.8,17.1,8.9,16.7z"/></g>
                <g><path d="M11,4.7l0.1-0.6c0.1-0.4,0.4-0.6,0.9-0.5c0.4,0.1,0.7,0.4,0.6,0.8L12.5,5c-0.1,0.4-0.4,0.6-0.9,0.5 S10.9,5.1,11,4.7z"/></g>
              </g>
              <g><path d="M10.7,21.5C4.8,21.5,0,16.6,0,10.7C0,4.8,4.8,0,10.7,0s10.7,4.8,10.7,10.7C21.5,16.6,16.6,21.5,10.7,21.5z M10.7,1.6c-5,0-9.1,4.1-9.1,9.1s4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1S15.8,1.6,10.7,1.6z"/></g>
            </g>
          </svg>
          :
          null
        }
        { tutorialUrl ? <a class="tutorial-link" href={tutorialUrl} target="_blank">Tutorial video</a> : null }
      </span>
    );
  };

}

export default withStyles(styles)(ComponentIcons);
